import React from 'react';
import { ReportHeroModel } from './ReportHero';

import HeroData from './HeroData';
import { Breadcrumbs } from '@/components';

export type NoBannerType = ReportHeroModel;

const NoBanner = (data: NoBannerType) => {
  const { title, breadcrumbs } = data.props;

  return (
    <div className="flex w-full flex-col sm:flex-row">
      <div className="container flex flex-col pt-3 pb-8 lg:pb-16">
        <h1 className="color-from-bg pt-4 pb-10 text-xl font-light sm:pt-14 sm:pb-14 sm:text-[35px] sm:leading-10 lg:text-[70px] lg:leading-[74px] xl:text-[80px]">
          {title}
        </h1>

        <Breadcrumbs className="py-3" data={breadcrumbs} />

        <HeroData className="py-3" {...data} />
      </div>
    </div>
  );
};

export default NoBanner;
